import { render, staticRenderFns } from "./ImagenesView.vue?vue&type=template&id=72284e35"
import script from "./ImagenesView.vue?vue&type=script&lang=js"
export * from "./ImagenesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports